import { ResetPasswordForm } from './ResetPasswordForm';

export type { TypeResetPasswordFormProps } from './types';
export default ResetPasswordForm;
